export default __webpack_public_path__ + "static/media/7.2d1f97f7.png";